import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  createAccCurrency: {
    id: 'createAccCurrency',
    defaultMessage: 'Create new currency',
  },
  enterAccCurrencyName: {
    id: 'enterAccCurrencyName',
    defaultMessage: 'Сurrency name',
  },
  createAccName: {
    id: 'createAccName',
    defaultMessage: 'Create new account',
  },
  selectAccName: {
    id: 'selectAccName',
    defaultMessage: 'Existing account',
  },
  enterAccName: {
    id: 'enterAccName',
    defaultMessage: 'Account name',
  },
  selectAccCurrency: {
    id: 'selectAccCurrency',
    defaultMessage: 'Existing currency',
  },
  selectCurrencyName: {
    id: 'selectCurrencyName',
    defaultMessage: 'Select currency',
  },
  createNewAccount: {
    id: 'createNewAccount',
    defaultMessage: 'Create new account',
  },
  account: {
    id: 'account',
    defaultMessage: 'Account',
  },
  currenciesNotFound: {
    id: 'currenciesNotFound',
    defaultMessage: 'Not Found',
  },
  selectOrCreateActor: {
    id: 'selectOrCreateActor',
    defaultMessage:
      'Select or create an actor to which you want to connect the account',
  },
  selectAccActor: {
    id: 'selectAccActor',
    defaultMessage: 'Select actor',
  },
  createAccActor: {
    id: 'createAccActor',
    defaultMessage: 'Create new actor',
  },
  selectLayerToPlace: {
    id: 'selectLayerToPlace',
    defaultMessage: 'Select layer where to place actor if needed.',
  },
  placeOnLayer: {
    id: 'placeOnLayer',
    defaultMessage: 'Place on layer',
  },
});

export default { ...globalIntl, ...m };
